<script setup>
import {computed, defineEmits, defineProps, onMounted, reactive, ref} from "vue";
import {couponConf} from "@/utils/config";
import RealName from "@/components/login/RealName.vue";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";
import store from "@/store";

const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf["lsq-xmair"];
    }
  }
});
const emit = defineEmits(['login'])
const showPayment = ref(false)
const payment = reactive({
  mobile: '',
  number: 1
})
const product = ref()
const productPrice = computed(() => {
  return parseFloat(product.value?.score_data?.[props.type.login]?.total) * parseFloat(payment.number)
})
const maxNumber = computed(() => {
  if (Object.keys(props.account).length < 1) return 1;
  return Math.floor(parseFloat(props.account.balance_miles) / parseFloat(product.value?.score_data?.[props.type.login]?.total))
})
const sendSms = ref(false)
const realname = ref(false)
const loading = ref(false)
const order_from = computed(() => store.state.orderFrom)
onMounted(() => {
  store.commit("getOrderFrom")
})
const payments = () => {
  if (!/^1[2-9]\d{9}$/.test(payment.mobile)) {
    return ElMessage.error("请输入收货手机号");
  }
  if (!sendSms.value && props.type.login !== 'xm_air') {
    sendSms.value = true
    return
  }
  sendSms.value = false
  loading.value = true
  let pay_params = JSON.stringify(props.type.login === 'xm_air' ? {
    access_token: props.account.access_token,
    user_id: props.account.user_id
  } : {cust_id: props.account.cust_id})

  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: product.value.id,
      uid: props.account.uid,
      pay_type: props.type.login,
      pay_params,
      number: payment.number,
      // auto_coupon: "1",
      mobile: payment.mobile,
      order_from: order_from.value
    },
    score_type: props.type.login
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
      return
    }
    if (props.type.login !== 'xm_air')
      router.replace({name: 'success', params: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => {
    loading.value = false
    ElMessage.error("兑换失败")
  })
}
</script>

<template>
  <!--  {{ // type }}-->
  <div class="coupon-list lsq-coupon-lst">
    <div class="product-header">
      <div class="bottom-header">
        <el-image :src="props.type?.headerImg"/>
      </div>
    </div>
    <div class="product-lst">
      <div class="product-item" v-for="(item,index) in couponLst?.[0]?.data" :key="index">
        <div class="product-values" :style="{backgroundImage:`url('${type.coupon}')`}">
          <div class="product-info">
            <div class="face-value">
              <el-text :type="type.login==='xm_air'?'primary':'danger'" class="face-value-unit">￥</el-text>
              <el-text :type="type.login==='xm_air'?'primary':'danger'" class="face-value-num">{{ item.face_value }}
              </el-text>
            </div>
            <h6  class="coupon-title">
              通用代金券
            </h6>
          </div>
          <div class="product-info">
            <div class="product-prices">
              <el-text :type="type.login==='xm_air'?'primary':'danger'" class="product-prices-values">
                {{ item?.score_data?.[type.login]?.total }}
              </el-text>
              <el-text style="font-size: .6rem">{{ item?.score_data?.[type.login]?.unit }}</el-text>
            </div>
            <div class="product-btn">
              <el-button :type="type.login==='xm_air'?'primary':'danger'" round @click="emit('login')"
                         v-if="Object.keys(account).length < 1" size="small">
                立即兑换
              </el-button>
              <el-button :type="type.login==='xm_air'?'primary':'danger'" round
                         v-else-if="Object.keys(account).length > 0 && parseInt(account.balance_miles) >= parseInt(item?.score_data?.[type.login]?.total)"
                         @click="product=item,showPayment=true" size="small">
                立即兑换
              </el-button>
              <el-button :type="type.login==='xm_air'?'primary':'danger'" round v-else size="small">
                {{ item?.score_data?.[type.login]?.unit }}不足
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="coupon-brand-jingle">
    <div class="coupon-brand-header">
      <h4>洛杉奇食品</h4>
      <el-image src="https://images.jifen360.com/lsq/lsq_ab_brand.png"/>
    </div>
    <el-card shadow="never">
      <div class="brand-info">
        <div class="brand-info-image">
          <el-image src="https://images.jifen360.com/lsq/jf.png"/>
        </div>
        <div class="brand-info-titles">
          <h5 class="brand-info-name">
            始于一九零八·非遗传承
            <el-image src="https://images.jifen360.com/lsq/jf-logo.png"/>
          </h5>
          <div>
            金凤扒鸡最早始于1908年，采用独特的制作工艺，用蜂蜜对鸡进行上色炸制，并用中药秘方老汤煮制。2006年被首批认定为“中华老字号”，2007年其传统手工制作技艺被列入河北省第二批省级非物质文化遗产名录。
          </div>
        </div>
      </div>
    </el-card>
    <el-card shadow="never">
      <div class="brand-info">
        <div class="brand-info-image">
          <el-image src="https://images.jifen360.com/lsq/lsq.png"/>
        </div>
        <div class="brand-info-titles">
          <h5 class="brand-info-name">
            洛杉奇烘焙·“面包大王”
            <el-image src="https://images.jifen360.com/lsq/lsq-logo.png"/>
          </h5>
          <div>
            洛杉奇面食制品在河北省素有“面包大王”的美誉，追求“专业品质、健康共享”的理念。主要产品有洛杉奇牌面包、蛋糕、西点、粽子、月饼等。
          </div>
        </div>
      </div>
    </el-card>
  </div>
  <div class="recharge-box">
    <div class="header">
      <el-image src="https://images.jifen360.com/lsq/recharge.png" v-if="type.login === 'xm_air'"/>
      <el-image src="https://images.jifen360.com/lsq/recharge-scal.png" v-if="type.login === 'scal'"/>
    </div>
    <div class="recharge-content">
      <div class="recharge-content-item" v-for="cont in type?.desc" :key="cont.title">
        <h4 v-if="cont.title" style="margin: 10px auto">{{ cont.title }}</h4>
        <ol class="recharge-values">
          <li v-for="(content,inx) in cont.content" :key="inx" v-html="content">
          </li>
        </ol>
      </div>
    </div>
  </div>
  <el-drawer v-model="showPayment" direction="btt" class="product-drawer" size="520" :show-close="false"
             style="background: #FAFAFA">
    <template #header>
      <div class="product-title" style="align-items: center">
        <div class="product-logo">
          <div class="product-its">
            <el-image :src="type?.product_i"/>
            <div class="face-value">
              <sup>
                <el-text type="danger">￥</el-text>
              </sup>
              <el-text type="danger" class="money">{{ parseFloat(product?.face_value) }}</el-text>
            </div>
          </div>
          <div class="tips">
            <b>
              <el-text type="danger">洛杉奇|金凤扒鸡|金凤鲜食城</el-text>
            </b>
          </div>
        </div>
        <div class="product-title-items" style="width: calc(100% - 120px);flex-basis: calc(100% - 120px);">
          <h4 class="title-h">{{ product?.title }}</h4>
          <div>
            <el-text type="info">无门槛 可叠加使用</el-text>
          </div>
          <div class="product-prices">
            <!--            <el-text type="info">兑换</el-text>-->
            <el-text :type="props.type?.login==='xm_air'?'primary':'danger'" class="product-prices-values">
              {{ product?.score_data?.[props.type?.login]?.total }}
            </el-text>
            <el-text>{{ props.type?.login === 'xm_air' ? '积分' : '里程' }}</el-text>
          </div>
        </div>
      </div>
    </template>
    <el-card>
      <div class="product-items">
        <div class="product-items-label">收货手机号</div>
        <div class="product-items-input">
          <el-input placeholder="请输入收货手机号" v-model="payment.mobile"/>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="product-items">
        <div class="product-items-label">兑换数量</div>
        <div class="product-items-input">
          <el-input-number :min="1" v-model="payment.number" :max="maxNumber > 0?maxNumber:1"/>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="product-items">
        <div class="product-items-label">可用{{ props.type?.login === 'xm_air' ? '积分' : '里程' }}</div>
        <div class="product-items-input">
          {{ account.balance_miles }}
        </div>
      </div>
      <div class="product-items">
        <div class="product-items-label">支付{{ props.type?.login === 'xm_air' ? '积分' : '里程' }}</div>
        <div class="product-items-input">
          {{ productPrice }}
        </div>
      </div>
    </el-card>
    <div class="btn">
      <el-button :type="props.type?.login==='xm_air'?'primary':'danger'" round @click="payments" size="large"
                 :disabled="productPrice > account.balance_miles" :loading="loading">立即兑换
      </el-button>
    </div>
  </el-drawer>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payments" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname"/>
</template>

<style scoped lang="less">
.lsq-coupon-lst {
  margin: 15px;
  background: #ffffff;
  border-radius: 12px;

  .product-lst {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    box-sizing: border-box;
    //padding: 5px;
    justify-content: space-between;

    .product-item {
      width: calc(100% / 2);
      flex-basis: calc(100% / 2);
      box-sizing: border-box;
      padding: 5px;
      text-align: center;

      .product-values {
        background-size: 100% 100%;

        .product-info {
          box-sizing: border-box;
          line-height: 1.4;
          padding: 5px 10px;
          //禁止换行
          white-space: nowrap;

          .el-button {
            width: 100%;
            height: 30px;
          }

          //display: inline-flex;
          .face-value {
            font-weight: 600;

            .face-value-num {
              font-size: 1.45rem;
            }
          }

          .product-prices-values {
            font-size: 1.2rem;
          }
        }
      }
    }
  }
}

.coupon-brand-jingle {
  margin: 15px;

  .coupon-brand-header {
    display: flex;
    height: 45px;
    align-items: center;
    margin-bottom: 10px;

    .el-image {
      width: 65%;
      margin-left: 8px;
      //超出部分省略号
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .el-card {
    --el-card-border-radius: 8px;
    margin-bottom: 15px;

    .brand-info {
      display: flex;

      .brand-info-image {
        flex-basis: 100px;
        width: 100px;

        .el-image {
          border-radius: 8px;
        }
      }
    }

    .brand-info-titles {
      width: calc(100% - 110px);
      margin-left: 10px;
      flex-basis: calc(100% - 110px);
      line-height: 1.45;

      .brand-info-name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;

        .el-image {
          width: 60px;
        }
      }

      div {
        font-size: .65rem;
      }
    }
  }
}

.recharge-box {
  margin: 15px;

  .recharge-content {
    box-sizing: border-box;
    padding: 15px;
    background: #ffffff;
    margin-top: -10px;
    border-radius: 0 5px 12px 12px;

    .recharge-values {
      padding-left: 15px;
      line-height: 1.75;
      font-size: .8rem;
      text-align: justify-all;
    }
  }
}

.product-drawer {
  .product-logo {
    flex-basis: 120px !important;
    width: 120px !important;
    background: #ffffff !important;
    box-sizing: border-box;
    padding: 10px 5px;

    .tips {
      text-align: center;

      .el-text {
        font-size: .5rem;
      }
    }

    .product-its {
      position: relative;

      .face-value {
        position: absolute;
        left: 0;
        right: 0;
        text-align: center;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;

        .money {
          font-size: 2.35rem;
        }

        sup {
          //display: inline-block;
          margin-top: -8px;
        }
      }
    }
  }

  .el-card {
    margin-bottom: 15px;
    --el-card-border-radius: 10px;
  }

  .product-items {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;

    .product-items-label {
      width: 120px;
      flex-basis: 120px;
    }

    .product-items-input {
      width: calc(100% - 120px);
      flex-basis: calc(100% - 120px);
      text-align: right;
    }

    & + .product-items {
      padding-top: 10px;
      border-top: var(--el-border);
      padding-bottom: 0;
    }
  }

  .btn {
    width: 95%;
    margin: 15px auto;

    .el-button {
      width: 100%;
    }
  }
}
</style>
